export default {
    path: "/things/:activeFilter",
    name: "Things",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/modules/thing/views/ThingsViewFilterView"
      ),
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "INSTALLER"],
    },
    beforeEnter: (to, from, next) => {
      to.params.activeFilter = from.params.activeFilter;
      return next();
    },
  };
  